import React, { FC, forwardRef } from 'react';
import { Value } from '@form/business/form.types';
import { AdvancedSelect, AdvancedSelectProps } from '@form/components/AdvancedSelect/AdvancedSelect.component';
import classnames from 'classnames';

interface Props extends Omit<AdvancedSelectProps, 'multiple' | 'onSelect' | 'value'> {
  values: Value[];
  onSelect: (values?: Value[]) => void;
}

export const MultiSelect: FC<Props> = forwardRef(({ className, values, onSelect, ...rest }, multiSelectRef) => {
  const rootClassName = classnames('multi-select', className);
  const rootOnSelect = (selection?: Value | Value[]) => {
    if (!selection) {
      onSelect(undefined);
    } else {
      onSelect(Array.isArray(selection) ? selection : [selection]);
    }
  };
  return (
    <AdvancedSelect
      ref={multiSelectRef}
      className={rootClassName}
      onSelect={rootOnSelect}
      value={values}
      {...rest}
      multiple
    />
  );
});
